import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, Inject, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { BaseDto } from '@models/base/baseDto.model';
import { ExpedienteSummaryDto } from '@models/expediente/expedienteSummary.model';
import { LoginService } from '@services/login/login.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { ButtonAddComponent } from 'src/app/component/button-add/button-add.component';
import { ButtonCancelDialogComponent } from 'src/app/component/button-cancel-dialog/button-cancel-dialog.component';
import { ButtonCloseDialogComponent } from 'src/app/component/button-close-dialog/button-close-dialog.component';
import { ButtonCloseComponent } from 'src/app/component/button-close/button-close.component';
import { ButtonDeleteAndCancelComponent } from 'src/app/component/button-delete-and-cancel/button-delete-and-cancel.component';
import { ButtonDeleteComponent } from 'src/app/component/button-delete/button-delete.component';
import { ButtonSaveComponent } from 'src/app/component/button-save/button-save.component';
import { BuscarExpedienteComponent } from '@views/busquedas/buscar-expediente/buscar-expediente.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { EmpresaUsuarioService } from '@services/empresaUsuario/empresaUsuario.service';
import { EmpresaUsuarioDto } from '@models/empresaUsuario/empresaUsuarioDto.model';
import { isFalsy } from 'utility-types';
import { EstadoEscritoService } from '@services/estadoEscrito/estadoEscrito.service';
import { CuentaContableService } from '@services/cuentaContable/cuentaContable.service';
import { CuentaCajaService } from '@services/cuentaCaja/cuentaCaja.service';
import { DtoBase } from '@models/base/dtoBase.model';
import { CuentaCajaDto } from '@models/cuentaCaja/cuentaCajaDto.model';
import { CuentaContableDto } from '@models/cuentaContable/cuentaContableDto.model';
import { TipoMonedaService } from '@services/tipoMoneda/tipoMoneda.service';
import { MatChipEditedEvent, MatChipInputEvent, MatChipsModule } from '@angular/material/chips';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MonedaDirective } from '@directives/moneda.directive';
import { SelectUsuariosEmpresaComponent } from 'src/app/component/select-usuarios-empresa/select-usuarios-empresa.component';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { EscritoDto } from '@models/escrito/escritoDto.model';
import { EscritoService } from '@services/escrito/escrito.service';
import { CreateEscritoRequest } from '@models/escrito/createEscritoRequest.model';
import { UpdateEscritoRequest } from '@models/escrito/updateEscritoRequest.model';
import { AccionesDialog } from '@models/base/identificadores.model';
import { TipoEscritoService } from '@services/tipoEscrito/tipoEscrito.service';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatSidenavModule } from '@angular/material/sidenav';

const useDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
const isSmallScreen = window.matchMedia('(max-width: 1023.5px)').matches;

@Component({
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatDialogModule, ButtonCloseDialogComponent, A11yModule, CommonModule, MatExpansionModule, ButtonSaveComponent, MatCardModule, MatIconModule, MatButtonModule, MatDividerModule, NgxSpinnerModule, MatTableModule, MatSliderModule, MatSlideToggleModule, MatMenuModule, MatDatepickerModule, MatRadioModule, MatSelectModule, FormsModule, MatSortModule, MatTooltipModule, MatPaginatorModule, MatRippleModule, MatNativeDateModule, BuscarExpedienteComponent, MatTabsModule, ButtonCancelDialogComponent, ButtonAddComponent, MatCheckboxModule, ButtonDeleteComponent, MatAutocompleteModule, MatChipsModule, MatTabsModule, MonedaDirective, SelectUsuariosEmpresaComponent, NgxMaskDirective,EditorComponent,DragDropModule,MatSidenavModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [provideNgxMask()],
  templateUrl: './dialog-form-escrito.component.html',
  styleUrl: './dialog-form-escrito.component.css',
  selector: 'app-dialog-form-escrito',
})


export class DialogFormEscritoComponent {

  init: EditorComponent['init'] = {
    plugins: [
      // Core editing features
      'anchor', 'autolink', 'charmap', 'codesample', 'emoticons', 'image', 'link', 'lists', 'media', 'searchreplace', 'table', 'visualblocks', 'wordcount', 'fullscreen', 'accordion', 'autosave', 'save',
      // Your account includes a free trial of TinyMCE premium features
      // Try the most popular premium features until Apr 25, 2025:
      // 'checklist', 'mediaembed', 'casechange', 'formatpainter', 'pageembed', 'a11ychecker', 'tinymcespellchecker', 'permanentpen', 'powerpaste', 'advtable', 'advcode', 'editimage', 'advtemplate','mentions', 'tinycomments', 'tableofcontents', 'footnotes', 'mergetags', 'autocorrect', 'typography', 'inlinecss', 'markdown','importword', 'exportword', 'exportpdf',
    ],
    toolbar: 'fullscreen restoredraft save| undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat | accordion ',
    tinycomments_mode: 'embedded',
    tinycomments_author: 'Author name',
    selector: 'textarea',
    language: 'es',
    toolbar_mode: 'sliding',
    contextmenu: 'link image table',
    skin: useDarkMode ? 'oxide-dark' : 'oxide',
    content_css: useDarkMode ? 'dark' : 'default',
    mergetags_list: [
      { value: 'First.Name', title: 'First Name' },
      { value: 'Email', title: 'Email' },
    ],
  };
  minimizado = false;
  visible = false;
  estadosescrito!: BaseDto[];
  expedienteDto!: ExpedienteSummaryDto;
  paises!: BaseDto[];
  empresaUsuarioDto!: EmpresaUsuarioDto;
  escrito: any;
  tiposEscrito!: BaseDto[];
  escritoDto!: EscritoDto;
  get f() { return this.form.controls; }
  accionesDialog = AccionesDialog;
  form!: FormGroup;
  formBuilder: FormBuilder = new FormBuilder;
  estadosEscrito!: DtoBase[];
  panelAbierto: 'escritos' | 'plantillas' | 'busqueda' | 'historial' | null = 'escritos';

  escritosAbiertos: any[] = [];
  selectedTabIndex = 0;
  filtroEscritos = '';
  filtroPlantillas = '';

  constructor(
    // public dialogRef: MatDialogRef<DialogFormEscritoComponent>,
    // @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private tipoEscritoService: TipoEscritoService,
    private escritoService: EscritoService,
    private empresaUsuarioService: EmpresaUsuarioService,
    private router: Router,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private loginService: LoginService,
    private estadoEscritoService: EstadoEscritoService,

  ) {

    this.getAllTiposEscrito()
    this.getAllEstadosEscrito()
  }

  ngOnInit(): void {

    this.escrito = null//this.data?.item || {};
    this.setForm();
  }
  onUsuarioSeleccionado(usuario: any) {
    this.form.get('AprobadoPor')?.setValue(usuario.id);
  }

toggleMinimizar(): void {
  this.minimizado = !this.minimizado;
}

  readonly separatorKeysCodes = [ENTER, COMMA] as const;

  getAllTiposEscrito() {
    this.spinner.show("spTipoEscrito")
    this.tipoEscritoService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spTipoEscrito")
          this.tiposEscrito = data
        },
        error => {
          this.spinner.hide("spTipoEscrito")
          this.snackBar.showError(error, "Error");
        })
  }

  getAllEstadosEscrito() {
    this.spinner.show('spEstadosEscrito')
    this.estadoEscritoService.getAll()
      .subscribe(
        data => {
          this.spinner.hide('spEstadosEscrito')
          this.estadosEscrito = data
        },
        error => {
          this.spinner.hide('spEstadosEscrito')
          this.snackBar.showError(error, "Error");
        })
  }


  setForm(): void {
    this.form = this.formBuilder.group({
      Id: [this.escrito?.id || null],
      Descripcion: [this.escrito?.descripcion || '', Validators.compose([Validators.maxLength(200)])],
      Observaciones: [this.escrito?.observaciones || '', Validators.compose([Validators.maxLength(500)])],
      FechaCreacion: [this.escrito?.fechaCreacion || null,],
      IdEstadoEscrito: [this.escrito?.estadoEscrito?.id || null],
      IdTipoEscrito: [this.escrito?.tipoEscrito?.id || null],
      IdExpediente: [this.escrito?.expediente?.id || null],
      Titulo: [this.escrito?.titulo || null, Validators.compose([Validators.required, Validators.maxLength(200)])],
      CuerpoHTML: [this.escrito?.cuerpoHTML || null, Validators.compose([Validators.required])],
    });
  }


  getAllUsuarioByIdEmpresa() {
    this.spinner.show('spPaises')
    this.empresaUsuarioService.getAll()
      .subscribe(
        data => {
          this.spinner.hide('spPaises')
          const empresaUsuarioDtoEncontrado = data.find(x => x.usuario.id === this.loginService.getIdUser());
          if (empresaUsuarioDtoEncontrado) {
            this.empresaUsuarioDto = empresaUsuarioDtoEncontrado;
            //this.form.get('IdPais')?.setValue(this.empresaUsuarioDto.empresa.pais.id);
          }

        },
        error => {
          this.spinner.hide('spPaises')
          this.snackBar.showError(error, "Error");
        })
  }

  selectExpediente($event: any) {
    this.expedienteDto = $event
    this.form.controls['IdExpediente'].setValue(this.expedienteDto.id)
  }

  cancelar() {
    // this.dialogRef.close({ event: AccionesDialog.Cancelar, data: this.data });
  }



  agregar() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.spinner.show("spEscrito")
    this.escritoService.create(this.setCreateEscritoRequest())
      .subscribe(
        data => {
          this.spinner.hide("spEscrito")
          this.snackBar.showSuccess('Registro creado con correctamente.', "Exito");
          // this.dialogRef.close({ event: AccionesDialog.Agregar, data: this.data.escrito, expediente: this.expedienteDto });
        },
        error => {
          this.spinner.hide("spEscrito")
          this.snackBar.showError(error, "Error");
          // this.dialogRef.close({ event: AccionesDialog.Cancelar, data: null });
        })
  }

  modificar() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.spinner.show("spEscrito")
    this.escritoService.update(this.setUpdateEscritoRequest())
      .subscribe(
        data => {
          this.spinner.hide("spEscrito")
          this.snackBar.showSuccess('Registro modificado correctamente.', "Exito");
          // this.dialogRef.close({ event: AccionesDialog.Modificar, data: this.data.escrito, expediente: this.expedienteDto });
        },
        error => {
          this.spinner.hide("spEscrito")
          this.snackBar.showError(error, "Error");
          // this.dialogRef.close({ event: AccionesDialog.Cancelar, data: null });
        })
  }

  eliminar() {
    this.spinner.show("spEscrito")
    this.escritoService.delete(this.escrito.id)
      .subscribe(
        data => {
          this.spinner.hide("spEscrito")
          this.snackBar.showSuccess('Registro eliminado correctamente.', "Exito");
          // this.dialogRef.close({ event: AccionesDialog.Eliminar, data: this.data.escrito, expediente: this.expedienteDto });
        },
        error => {
          this.spinner.hide("spEscrito")
          this.snackBar.showError(error, "Error");
          // this.dialogRef.close({ event: AccionesDialog.Cancelar, data: null });
        })
  }

  setCreateEscritoRequest(): CreateEscritoRequest {
    const createEscritoRequest = new CreateEscritoRequest();

    createEscritoRequest.descripcion = this.form.controls['Descripcion'].value;
    createEscritoRequest.idEstadoEscrito = this.form.controls['IdEstadoEscrito'].value || null;
    createEscritoRequest.idTipoEscrito = this.form.controls['IdTipoEscrito'].value || null;
    createEscritoRequest.titulo = this.form.controls['Titulo'].value || null;
    createEscritoRequest.idExpediente = this.form.controls['IdExpediente'].value || null;
    createEscritoRequest.cuerpoHTML = this.form.controls['CuerpoHTML'].value || null;
    createEscritoRequest.fechaCreacion = this.form.controls['FechaCreacion'].value || null;
    createEscritoRequest.cuerpoHTML = this.form.controls['CuerpoHTML'].value || null;

    return createEscritoRequest;

  }


  setUpdateEscritoRequest(): UpdateEscritoRequest {
    const updateEscritoRequest = new UpdateEscritoRequest();

    updateEscritoRequest.id = this.form.controls['Id'].value;
    updateEscritoRequest.descripcion = this.form.controls['Descripcion'].value;
    updateEscritoRequest.idEstadoEscrito = this.form.controls['IdEstadoEscrito'].value || null;
    updateEscritoRequest.idTipoEscrito = this.form.controls['IdTipoEscrito'].value || null;
    updateEscritoRequest.titulo = this.form.controls['Titulo'].value || null;
    updateEscritoRequest.idExpediente = this.form.controls['IdExpediente'].value || null;
    updateEscritoRequest.cuerpoHTML = this.form.controls['CuerpoHTML'].value || null;

    return updateEscritoRequest;

    return updateEscritoRequest;
  }


  onReset() {
    this.form.reset();
  }

  trackByescritos(index: number, escrito: any): any { return escrito; }



  async getEscritoById(id: number) {
    this.spinner.show("spView")
    await this.escritoService.getById(id)
      .subscribe(
        data => {
          this.spinner.hide("spView")
          this.escritoDto = data
          this.setForm();
        },
        error => {
          this.spinner.hide("spView")
          this.snackBar.showError(error, "Error");
        })
  }

  esUrlValida(url: string): boolean {
    try {
      new URL(url);
      return true;
    } catch (_) {
      return false;
    }
  }

  abrirUrl(url: string): void {
    if (this.esUrlValida(url)) {
      window.open(url, '_blank');
    }
  }

  togglePanel(panel: any) {
    this.panelAbierto = this.panelAbierto === panel ? null : panel;
  }

  abrirEscrito(escrito: any) {
    if (!this.escritosAbiertos.find(e => e.id === escrito.id)) {
      this.escritosAbiertos.push({ ...escrito });
    }
    this.selectedTabIndex = this.escritosAbiertos.findIndex(e => e.id === escrito.id);
  }

  abrirPlantilla(plantilla: any) {
    const nueva = {
      id: 'plantilla-' + Date.now(),
      titulo: plantilla.titulo + ' (copia)',
      contenido: plantilla.contenido
    };
    this.escritosAbiertos.push(nueva);
    this.selectedTabIndex = this.escritosAbiertos.length - 1;
  }

  guardarEscrito(escrito: any) {
    // Implementar lógica de guardado
    console.log('Guardando:', escrito);
  }

  cerrarEscrito(index: number) {
    this.escritosAbiertos.splice(index, 1);
    if (this.selectedTabIndex >= this.escritosAbiertos.length) {
      this.selectedTabIndex = this.escritosAbiertos.length - 1;
    }
  }

  actualizarContenido(index: number, nuevoContenido: string) {
    this.escritosAbiertos[index].contenido = nuevoContenido;
  }
}


